/* eslint-disable @typescript-eslint/no-explicit-any */

import useAxiosPrivate from "@/hooks/useAxiosPrivate";
import { formatDate } from "@/utils";
import {
	Accordion,
	AccordionBody,
	AccordionHeader,
	AccordionList,
	Badge,
} from "@tremor/react";
import { useRef, useState } from "react";
import ReusableTable from "../components/ReusableTable";

interface UserLogFilters {
	from?: string;
	to?: string;
	userId?: string;
	action?: string;
	start?: number;
	sort?: string;
	search?: string;
	limit?: number;
	[key: string]: any;
}

export default function Transactions() {
	const [data, setData] = useState<{ data: any[]; total: number } | null>(null);
	const axiosPrivate = useAxiosPrivate();
	const latestRequest = useRef(0);

	const getUserLogs = async (filters?: UserLogFilters) => {
		const requestId = ++latestRequest.current;
		try {
			const params = new URLSearchParams();

			if (filters) {
				for (const [key, value] of Object.entries(filters)) {
					if (value !== null && value !== undefined && value !== "") {
						params.append(key, String(value));
					}
				}
			}

			const queryString = params.toString();
			const url = queryString ? `/auth/nbUsers/logs?${queryString}` : "/auth/nbUsers/logs";

			const response = await axiosPrivate.get(url);

			if (requestId === latestRequest.current) {
				setData(response.data);
			}

			return response.data;
		} catch (error) {
			console.error("Error fetching user logs:", error);
		}
	};

	const columns = [
		{
			key: "email",
			header: "Email",
			render: (value: string) => <div>{value}</div>,
		},
		{
			key: "action",
			header: "Ενέργεια",
			render: (value: string) => (
				<Badge
					className=""
					color={
						value === "created"
							? "green"
							: value === "updated"
								? "yellow"
								: "red"
					}
				>
					{value === "created" && "Δημιούργησε"}
					{value === "updated" && "Άλλαξε"}
					{value === "deleted" && "Διέγραψε"}
				</Badge>
			),
		},
		// {
		// 	key: "resource",
		// 	header: "Οντότητα",
		// 	render: (value: string) => (
		// 		<div>
		// 			{value?.includes(",")
		// 				? value.split(",").map((e) => <div key={e}>{e}</div>)
		// 				: value}
		// 		</div>
		// 	),
		// },
		{
			key: "value",
			header: "Τιμές",
			render: (value: string) => {
				const parsed = JSON.parse(value);
				const jsonElements = Object.entries(parsed);
				return (
					<AccordionList style={{ width: "500px" }} className="max-w-sm">
						{jsonElements.map((e) => {
							const data = JSON.parse(JSON.stringify(e[1]));
							return (
								<Accordion key={e[0]} className="max-w-sm">
									<AccordionHeader
										className=" max-w-sm text-sm font-medium text-tremor-content-strong dark:text-dark-tremor-content-strong"
										key={e[0]}
									>
										{e[0]}
									</AccordionHeader>
									<AccordionBody className=" max-w-l">
										{data && Array.isArray(data) ? (
											data.map((e) => {
												return (
													<div key={e.key}>
														<b>{e.key}: </b>
														{e.value && <Badge color="blue">{e?.value}</Badge>}
														{e.oldValue !== undefined && (
															<Badge color="orange">{e?.oldValue}</Badge>
														)}
														{e?.newValue !== undefined && (
															<>
																→ <Badge color="green">{e?.newValue}</Badge>
															</>
														)}
													</div>
												);
											})
										) : typeof data === "object" ? (
											data &&
											Object.entries(data).map(([key, value]) => {
												if (
													key !== "created_at" &&
													key !== "updated_at" &&
													key !== "is_deleted"
												)
													return (
														<div key={key}>
															<b>{key}:</b>
															<span className="text-cyan-500">
																{value as string}
															</span>
														</div>
													);
											})
										) : (
											<div>
												<b>{e[0]}:</b>
												<span className="text-cyan-500"> {data}</span>
											</div>
										)}
									</AccordionBody>
									{/* <div key={e[0]}>{JSON.stringify(e[1])}</div> */}
								</Accordion>
							);
						})}
					</AccordionList>
				);
			},
		},

		{
			key: "created_at",
			header: "Ημ/νία Εγγραφής",
			render: (value: string) =>
				formatDate(value, { simple: true, withTime: true }),
		},
	];
	return (
		<div className="flex-1 space-y-4 p-8 pt-6">
			<div className="flex items-center justify-start space-y-2">
				<h2 className="text-2xl font-bold tracking-tight">
					Καταγραφή ενεργειών
				</h2>
			</div>
			<div className="flex flex-col space-y-4">
				{/* {JSON.stringify(data)} */}

				<ReusableTable
					searchFunction={getUserLogs}
					data={data?.data ?? []}
					columns={columns}
					defaultSort={{ key: "created_at", direction: "desc" }}
					period="Τελευταίες 7 ημέρες"
					enablePagination={true}
					totalItems={data?.total ?? 0}
					itemsPerPageOptions={[50, 100, 200]}
					defaultItemsPerPage={50}
					// onRowClick={handleRowClick}
					searchableFields={["email"]}
					dateRangeFilter={true}
				/>
			</div>
		</div>
	);
}
